import loadPreactModule from "../../utils/loadPreactModule";
import renderPreactWithProps from "../../utils/renderPreactWithProps";
import curry from "../../lib/core/functional/curry";

let _element;
let _renderedNode;

function createInformerElement() {
    _element = document.createElement("div");
    _element.classList.add("informers", "hidden");
    document.body.appendChild(_element);
    return _element;
}

function clearInformerElement(element, renderer) {
    if (_renderedNode) {
        renderer.preact.render(null, element, _renderedNode);
        return element;
    } else {
        return element;
    }
}

function getInformerElement(renderer) {
    if (_element) {
        return clearInformerElement(_element, renderer);
    } else {
        return createInformerElement();
    }
}

const makeCallback = curry((callback, event) => {
    _element.classList.add("hidden");
    event.preventDefault();
    callback();
    return false;
});

export const renderInformer = curry(function renderInformer(renderModule, element, ogProps) {
    const { possitiveAction, negativeAction } = ogProps;
    const props = {
        ...ogProps,
        possitiveAction: possitiveAction
            ? {
                  ...possitiveAction,
                  callback: makeCallback(possitiveAction.callback),
              }
            : null,
        negativeAction: negativeAction
            ? {
                  ...negativeAction,
                  callback: makeCallback(negativeAction.callback),
              }
            : null,
    };
    _renderedNode = renderModule(props);
    element.classList.remove("hidden");
});

const onModule = curry(function onModule(element, config, [renderer, Module]) {
    return renderInformer(renderPreactWithProps(renderer, Module, element), element, config || {});
});

const configLessOnModule = curry(function configLessOnModule(element, _config, [renderer, Module]) {
    return renderInformer(renderPreactWithProps(renderer, Module, element), element);
});

const internalLoader = () => import("./module").then((module) => module.default);

const _renderer = curry(function _renderer(onModule, context, config) {
    const element = getInformerElement(renderer);
    return loadPreactModule("Informer", context, {}, internalLoader).then(
        onModule(element, config)
    );
});

const renderer = _renderer(onModule);

export default renderer;

export const renderAsModule = _renderer(configLessOnModule);
